export class Especialidade {
    
    id: number = 0;
    
    nome: string = '';

    constructor() {
    }
}
